// BusinessTypeモデルのid
const food = 1
const retail = 2
const hotel = 3
const salon = 4
const activity = 5
const others = 6

export const externalAccountsConst = [
  {
    id: 'yahooLoco',
    name: 'yahoo_loco',
    businessTypes: [food, retail, hotel, salon, activity, others]
  },
  {
    id: 'tabelog',
    name: 'tabelog',
    businessTypes: [food]
  },
  {
    id: 'tripAdvisor',
    name: 'trip_advisor',
    businessTypes: [food, retail, hotel]
  },
  {
    id: 'retty',
    name: 'retty',
    businessTypes: [food]
  },
  {
    id: 'hotPepperGourmet',
    name: 'hot_pepper_gourmet',
    businessTypes: [food]
  },
  {
    id: 'gnavi',
    name: 'gnavi',
    businessTypes: [food]
  },
  {
    id: 'hotPepperBeauty',
    name: 'hot_pepper_beauty',
    businessTypes: [salon]
  },
  {
    id: 'asoview',
    name: 'asoview',
    businessTypes: [activity]
  },
]
